import { render, staticRenderFns } from "./select.vue?vue&type=template&id=5c28276e&scoped=true&"
import script from "./select.ts?vue&type=script&lang=ts&"
export * from "./select.ts?vue&type=script&lang=ts&"
import style0 from "./select.scss?vue&type=style&index=0&id=5c28276e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c28276e",
  null
  
)

export default component.exports